import axios from "axios";
import { API_BASE_URL } from "../../../constants";

// ---- Roster overrides (coach / admin roster management) -----------------
// One document per team: players hidden from the roster + players added to
// it. Applied server-side wherever a roster is loaded (CacheShare,
// onboarding, coach dashboard), so every surface shows the reconciled roster.

const rosterAuth = () => ({
  headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
});

export const fetchRosterOverrides = async (teamId) => {
  const res = await axios.get(`${API_BASE_URL}/roster/overrides/`, {
    ...rosterAuth(),
    params: { teamId },
  });
  return res.data;
};

export const hideRosterPlayer = async ({ teamId, playerId, name, league, teamName }) => {
  const res = await axios.post(
    `${API_BASE_URL}/roster/overrides/hide/`,
    { teamId, playerId, name, league, teamName },
    rosterAuth(),
  );
  return res.data;
};

export const unhideRosterPlayer = async ({ teamId, playerId }) => {
  const res = await axios.post(
    `${API_BASE_URL}/roster/overrides/unhide/`,
    { teamId, playerId },
    rosterAuth(),
  );
  return res.data;
};

export const addRosterPlayer = async ({ teamId, league, teamName, fullName, position, jerseyNumber, athleteEmail }) => {
  const res = await axios.post(
    `${API_BASE_URL}/roster/overrides/add/`,
    { teamId, league, teamName, fullName, position, jerseyNumber, athleteEmail },
    rosterAuth(),
  );
  return res.data;
};

export const removeRosterPlayer = async ({ teamId, playerId }) => {
  const res = await axios.delete(
    `${API_BASE_URL}/roster/overrides/add/${encodeURIComponent(playerId)}/`,
    { ...rosterAuth(), params: { teamId } },
  );
  return res.data;
};
